/**
 * Runtime client config set in `index.tsx` `main()` after `fetchClientConfig` hydrates the store.
 * Non-React code (logger, i18n) can read via getClientConfigRuntime() when config has been loaded.
 * Minimal shape to avoid importing the store/slice here.
 */

export interface ClientConfigRuntime {
  appEnv: string
  version: string | undefined
  logLevel: string
  termsUrl: string | undefined
  privacyUrl: string | undefined
  shopifyAppHandle: string | undefined
  [key: string]: unknown
}

let runtimeConfig: ClientConfigRuntime | null = null

export function setClientConfigRuntime(config: ClientConfigRuntime): void {
  runtimeConfig = config
}

export function getClientConfigRuntime(): ClientConfigRuntime | null {
  return runtimeConfig
}
